import React from 'react';
import {Redirect} from 'react-router-dom';

import User from 'Services/User';

class TwoFactorUnverified extends React.Component {
    /**
     * @var state
     * @type {{shouldVerify: null}}
     */
    state = {
        shouldVerify: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.checkShouldVerify();

        User.on('change', this.checkShouldVerify);
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        User.removeListener('change', this.checkShouldVerify);
    };

    /**
     * @method checkShouldVerify
     */
    checkShouldVerify = () => {
        // TODO might need to convert the dates below to DateTime objects to compare accurately and check if null.
        this.setState({
            shouldVerify: User.loggedIn && User.data.two_factor_secret !== null &&
                (User.data.two_factor_verified_at === null || User.data.last_login_date.iso_string > User.data.two_factor_verified_at.iso_string)
        });
    };

    /**
     * @method render
     * @return {null|*|JSX.Element}
     */
    render () {
        const {shouldVerify} = this.state;
        const {component} = this.props;

        if (shouldVerify === null) {
            return null;
        }

        return shouldVerify ? component : <Redirect to="/" />;
    }
}

export default TwoFactorUnverified;
